import React, { FC, ReactNode } from 'react';

import styled from '@emotion/styled';

import { Box, COLORS, Text } from '@clutter/clean';

const InfoCardLabel = styled.div`
  color: ${COLORS.cloud};
  background: ${COLORS.tealPrimary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 60px;
  height: 60px;
`;

export const InfoCardItem: FC<{
  title?: ReactNode;
  subtitle?: ReactNode;
  label?: string;
  icon: string;
}> = ({ icon, title, subtitle, label }) => (
  <Box.FlexItem flexBasis={['100%', null, '33.3333%']}>
    <Box.Flex gap="12px" flexDirection="column">
      {label && (
        <InfoCardLabel>
          <Text.Title size="extraSmall">{label}</Text.Title>
        </InfoCardLabel>
      )}

      <Box margin="24px 0" height="70px">
        <img src={icon} alt="" style={{ height: '100%' }} />
      </Box>

      {title && <Text.Title size="extraSmall">{title}</Text.Title>}
      {subtitle && <Text.Body>{subtitle}</Text.Body>}
    </Box.Flex>
  </Box.FlexItem>
);
